import { fetchFromAPI } from 'utils/api';

export const updateAllTemperaturePoints = (resource) => {
  return fetchFromAPI('/admin/temperature_points/update_all', {
    method: 'put',
    body: JSON.stringify({ resource }),
  })
    .then((response) => response) // Return full response including paradigm
    .catch((response) => {
      throw response;
    });
};
